export default {
  nav: {
    home: 'الصفحة الرئيسية',
    about: 'من نحن',
    products: 'تعريف بالمنتجات',
    materials: 'مواد الكربون الجديدة',
    solventfree: 'لاصق خالي من المذيبات',
    estersolvent: 'لاصق مذيبات الإستر',
    alcoholicsolvent: 'لاصق مذيبات الكحول',
    news: 'المركز الإخباري',
    support: 'الدعم الفني',
    hr: 'الموارد البشرية',
    contact: 'اتصل بنا',
    more: 'المزيد',
    language: 'اختيار اللغة'
  },
  menu: {
    loading: 'جار التحميل...',
    home: 'الصفحة الرئيسية',
    newCarbonMaterials: 'مواد الكربون الجديدة',
    adhesive: 'المواد اللاصقة',
    technicalSupport: 'الدعم الفني',
    newsCenter: 'المركز الإخباري',
    humanResource: 'الموارد البشرية',
    aboutUs: 'من نحن',
    contactUs: 'اتصل بنا'
  },
  header:{
    menu: 'القائمة',
    language: 'اللغة'
  },
  footer: {
    contactTitle: 'طرق الاتصال',
    addressTitle: 'العنوان',
    address: 'رقم 688، طريق شيفينغ، منطقة نانتايهو الجديدة، مدينة هوتشو، مقاطعة تشجيانغ، الصين',
    addressCn: 'رقم 688، طريق شيفينغ، منطقة نانتايهو الجديدة، مدينة هوتشو، مقاطعة تشجيانغ، الصين'
  },
  languageDialog: {
    title: 'اختر لغتك',
    current: 'الاختيار الحالي',
    switchSuccess: 'تم تغيير اللغة بنجاح',
    description: 'نحن ملتزمون بتوفير دعم متعدد اللغات للمستخدمين العالميين، لتمكين المزيد من الأشخاص من استخدام خدماتنا بسهولة.',
    contactNote: 'إذا كنت بحاجة إلى دعم بلغات أخرى، يرجى الاتصال بفريق خدمة العملاء لدينا.'
  },
  home: {
    title: 'الصفحة الرئيسية',
    banner: {
      title: 'رؤية عالمية، خدمات محلية',
      subtitle: 'فريق دولي، يوفر لك خدمات احترافية محلية',
      heroTitle: 'مواد جديدة تقنيات جديدة اختراقات جديدة',
      heroSubtitle: 'شركة متخصصة في تصنيع المنتجات الكيميائية، ملتزمة بتزويد العملاء بمنتجات وخدمات عالية الجودة',
      viewProducts: 'عرض المنتجات',
      learnMore: 'تعرف على المزيد'
    },
    about: {
      title: 'ملف الشركة',
      content: 'من خلال زيادة الاستثمار المستمر في البحث والتطوير، تواصل شركة هوتشو أوميكيميكال المحدودة تطوير منتجات جديدة لتلبية احتياجات العملاء. تشمل مجموعتها من المواد اللاصقة للتغليف المرن المركب أربع سلاسل رئيسية: قابلة للذوبان في الإستر، وقابلة للذوبان في الكحول، وقابلة للذوبان في الماء، وخالية من المذيبات؛ بالإضافة إلى سلسلة المواد اللاصقة للهياكل الهندسية، بما في ذلك لاصق ألواح الأبواب، ولاصق تغطية الحديد، ولاصق إغلاق البطاريات وغيرها، والتي حظيت بثناء واسع في السوق.',
      companyIntro: 'شركة هوتشو أوميكيميكال المحدودة هي إحدى الشركات الفرعية التي استثمرت فيها شركة Carbon Material LLC، ومقرها هيوستن، تكساس، الولايات المتحدة الأمريكية، في الصين. تقع الشركة في مدينة هوتشو المريحة في دلتا نهر اليانغتسي، بالقرب من مطار هانغتشو الدولي، ومطار نانجينغ لوكو الدولي، ومطار شنغهاي بودونغ الدولي، مما يجعل وسائل النقل مريحة للغاية.',
      companyPhilosophy: 'تلتزم الشركة بفلسفة العمل القائمة على "النزاهة، والإتقان، والابتكار"، ورؤيتها للتطوير هي موازنة احتياجات البشر من الطاقة والبيئة من خلال الابتكار، ودفع الصناعة نحو اتجاه صديق للبيئة وأخضر من خلال البحث والتطوير المتعمق والمنتجات وتقنيات التطبيق المبتكرة باستمرار.',
      viewMore: 'عرض المزيد',
      viewDetails: 'عرض التفاصيل'
    },
    meta: {
      description: 'شركة هوتشو أوميكيميكال المحدودة - شركة متخصصة في تصنيع المنتجات الكيميائية، ملتزمة بموازنة احتياجات البشر من الطاقة والبيئة من خلال الابتكار'
    },
    products: {
      title: 'منتجاتنا',
      product1: {
        name: 'لاصق خالي من المذيبات',
        description: 'لاصق مركب صديق للبيئة وخالٍ من المذيبات، مناسب لمجموعة متنوعة من سيناريوهات التطبيق مثل تغليف المواد الغذائية'
      },
      product2: {
        name: 'لاصق مذيب إستري',
        description: 'لاصق مركب مذيب إستري عالي الأداء، يتميز بقوة ربط ممتازة'
      },
      product3: {
        name: 'لاصق هيكلي هندسي',
        description: 'لاصق احترافي للاستخدامات الهيكلية الهندسية، يستخدم على نطاق واسع في مجالات البناء والصناعة'
      }
    },
    advantages: {
      title: 'مزايا لدينا',
      innovation: {
        title: 'الابتكار التقني',
        description: 'استثمار مستمر في البحث والتطوير، وتقديم منتجات وحلول مبتكرة باستمرار'
      },
      quality: {
        title: 'ضمان الجودة',
        description: 'نظام صارم لإدارة الجودة لضمان الجودة العالية والموثوقية للمنتجات'
      },
      environment: {
        title: 'المفهوم البيئي',
        description: 'ملتزمون بأن نكون صديقين للبيئة وخضر، وتطوير منتجات كيميائية مستدامة'
      },
      service: {
        title: 'الخدمة الاحترافية',
        description: 'فريق تقني متخصص، يوفر للعملاء دعمًا فنيًا شاملاً'
      }
    }
  },
  about: {
    title: 'من نحن',
    subtitle: 'تعرف على تاريخنا ورسالتنا وقيمنا',
    introHeader: 'مقدمة عن الشركة',
    introTitle: 'موازنة احتياجات البشر من الطاقة والبيئة من خلال الابتكار',
    companyIntro: 'تأسست شركتنا في عام 2005، وهي شركة تركز على البحث والتطوير وإنتاج المنتجات عالية التقنية. بعد سنوات من التطوير، أصبحنا شركة رائدة في الصناعة، ويتم تصدير منتجاتنا إلى العديد من البلدان والمناطق حول العالم.',
    vr: {
      panoramicVR: 'جولة بانورامية بتقنية الواقع الافتراضي (VR)',
      visitUs: 'لا حاجة للحضور، ما عليك سوى زيارتنا',
      slideMouse: 'حرك الماوس للمتابعة في الجولة'
    },
    meta: {
      description: 'تعرف على تاريخ ورسالة وقيم شركة هوتشو أوميكيميكال المحدودة، التزامنا بالبحث والتطوير المبتكر للمنتجات الكيميائية'
    },
    teamIntro: 'لدينا فريق بحث وتطوير عالي الكفاءة، يقدم باستمرار منتجات مبتكرة لتلبية احتياجات السوق. تم تجهيز قاعدة الإنتاج لدينا بمعدات إنتاج متقدمة ونظام كامل لإدارة الجودة لضمان الجودة العالية والموثوقية للمنتجات.',
    philosophy: 'نلتزم بفلسفة الشركة القائمة على "الابتكار، والجودة، والنزاهة، والربح المشترك"، وملتزمون بتزويد العملاء بأفضل المنتجات والخدمات، والتطور المشترك مع الشركاء لتحقيق المنفعة المتبادلة والربح المشترك.',
    culture: {
      title: 'ثقافة الشركة',
      innovation: {
        title: 'الابتكار',
        description: 'نحن ملتزمون بالابتكار التقني والبحث والتطوير للمنتجات، وتقديم منتجات جديدة تلبي احتياجات السوق باستمرار'
      },
      quality: {
        title: 'الجودة',
        description: 'نظام صارم لإدارة الجودة لضمان أن كل منتج يلبي أعلى المعايير'
      },
      integrity: {
        title: 'النزاهة',
        description: 'التعامل مع الناس بصدق وتأسيس الأعمال بالثقة، وبناء علاقات تعاون طويلة الأمد ومستقرة'
      },
      philosophy: {
        title: 'الفلسفة',
        description: 'موازنة احتياجات البشر من الطاقة والبيئة من خلال الابتكار، ودفع التنمية المستدامة للصناعة'
      }
    },
    timeline: {
      title: 'تاريخ التطور',
      item1: {
        title: 'تأسيس الشركة',
        description: 'استثمرت الشركة 4 ملايين دولار أمريكي وأسست "شركة هوتشو أوميكيميكال المحدودة" في هوتشو'
      },
      item2: {
        title: 'الانتهاء من البناء وبدء الإنتاج',
        description: 'تم الانتهاء من بناء الشركة وبدأت الإنتاج في مايو 2005'
      },
      item3: {
        title: 'تطوير منتجات جديدة',
        description: 'طورت الشركة مواد كيميائية دقيقة وظيفية جديدة لمعالجة المياه، وتواصل الابتكار، وتطوير منتجات معالجة المياه الصديقة للبيئة وعالية الكفاءة باستمرار'
      },
      item4: {
        title: 'توسيع المنتجات',
        description: 'لتلبية احتياجات السوق، قامت الشركة بالبحث والتطوير لمنتجات لاصق البولي يوريثان الخالي من المذيبات'
      },
      item5: {
        title: 'الارتقاء بالصناعة',
        description: 'تتماشى الشركة مع اتجاه العصر، وتدخل صناعات الطاقة والمواد الجديدة، وتوسع نموذج أعمالها ونطاق عملها، وتستخدم مزاياها كشركة كيميائية لدفع التطور السريع لمواد الكربون الجديدة'
      },
      item6: {
        title: 'استعادة المذيبات',
        description: 'استكشفت الشركة مجالًا جديدًا لاستعادة المذيبات، وأنشأت خط إنتاج لتنقية وتصفية مذيب NMP، لإعادة تدوير واستخدام مذيب NMP'
      },
      item7: {
        title: 'إنجازات براءات الاختراع',
        description: 'حتى ذلك العام، حصلت الشركة بالفعل على 11 براءة اختراع ممنوحة (بما في ذلك براءة اختراع أمريكية وبراءة اختراع أوروبية)'
      },
      item8: {
        title: 'زيادة الطاقة الإنتاجية',
        description: 'تم زيادة الطاقة الإنتاجية السنوية لمنتجات اللاصق الخالي من المذيبات من 3000 طن سنويًا إلى 6000 طن سنويًا'
      },
      item9: {
        title: 'اعتراف السوق',
        description: 'حصل أداء وجودة المنتج الجديد لللاصق أحادي المكون الخالي من المذيبات الذي تم تطويره حديثًا على اعتراف واسع في السوق، واستحوذ على حصة سوقية مستقرة ومتنامية'
      },
      item10: {
        title: 'تنويع المنتجات',
        description: 'بدأت المنتجات التي طورتها الشركة حديثًا والتي تم اختبارها في السوق، مثل برايمر PVDC المائي، ولاصق تركيب أغشية البثور للتغليف الطبي، واللاصق المقاوم للشد والتعقيم، ولاصق تغطية سبائك الألومنيوم، ودهانات الخشب، تحظى باعتراف السوق تدريجياً'
      },
      item11: {
        title: 'بناء مركز البحث والتطوير',
        description: 'سيبدأ بناء مركز البحث والتطوير الجديد للشركة، مع دعوة المواهب من جميع المجالات للانضمام مبكرًا'
      }
    }
  },
  products: {
    title: 'تعريف بالمنتجات',
    meta: {
      description: 'تعريف بمنتجات شركة هوتشو أوميكيميكال المحدودة - لاصق مركب للتغليف المرن، لاصق هيكلي هندسي ومنتجات كيميائية احترافية أخرى'
    },
    viewDetails: 'عرض التفاصيل',
    cancel: 'إلغاء',
    jumpToDetails: 'الانتقال إلى الصفحة التفصيلية',
    categories: {
      solventFree: {
        title: 'سلسلة المواد اللاصقة الخالية من المذيبات',
        description: 'لاصق مركب عالي الأداء وخالٍ من المذيبات، مناسب لمجموعة متنوعة من مواد التغليف'
      },
      esterSolvent: {
        title: 'سلسلة المواد اللاصقة القابلة للذوبان في الإستر',
        description: 'لاصق مركب مذيب إستري احترافي، يتميز بأداء ربط ممتاز'
      }
    },
    solventFree: {
      product1: {
        application: 'تطبيق واسع',
        infoLabel1: 'T.F ON ANSI 31-2024',
        infoValue1: 'تسوس PAA السريع',
        descriptions: [
          'إيزوسيانات أروماتية وأليفاتية مختلطة',
          'مقاومة تصلب 13 درجة مئوية AL RCPP',
          'PAA بعد التصلب في PootiStaff >0.01 mg/kg'
        ]
      }
    }
  },
  materials: {
    title: 'تعريف بالمواد',
    learnMore: 'تعرف على المزيد',
    information: 'معلومات',
    detailModal: {
      description: 'وصف المنتج',
      specifications: 'المواصفات والمعايير',
      applications: 'مجالات التطبيق',
      features: 'الخصائص والمزايا',
      close: 'إغلاق',
      contact: 'اتصل بنا'
    },
    material1: {
      category: 'مواد الكربون',
      title: 'جديد',
      description: 'يعد الكربون أحد العناصر الأكثر ارتباطًا وأهمية الموجودة في الطبيعة. وفي الوقت نفسه، نظرًا لتركيبها المجهري الخاص، تتميز مواد الكربون المكونة من ستين عنصرًا بخصائص فريدة، وكذلك مرحلة الكربون النانوي، ويتم الآن تطوير وتصنيع مواد الكربون بشكل مستمر.',
      placeholder: 'مواد الكربون الجديدة'
    },
    material2: {
      title: 'أنابيب الكربون النانوية',
      description: 'أنابيب الكربون النانوية هي مادة نانوية متكونة. خصائصها الهيكلية منظمة للغاية. إضافتها إلى الخرسانة لا تجعل البطارية موصلة للكهرباء بشكل فعال للحفاظ على قدرة حرارية نوعية كافية. كموصل في الاتجاه الموصل والموصلية السائلة الأولى لبطارية أيونات الليثيوم.',
      placeholder: 'هيكل أنابيب الكربون النانوية'
    },
    material3: {
      title: 'معجون موصل',
      description: 'تختلط نقاط نقل الكربون في شكل تجمعات أثناء عملية الإنتاج مع مختلف المعاجين البلورية وأيونات الليثيوم ومكونات كبريتيد الكربون الخاصة بها. كأحد أنابيب الكربون النانوية في نظام المذيبات السائلة، يتراوح محتواها عمومًا بين 2-10٪، واللزوجة معتدلة، مما يوفر راحة كبيرة للتطبيقات النهائية.',
      placeholder: 'معجون موصل'
    },
    material4: {
      title: 'ألياف الكربون النانوية',
      description: 'ألياف الكربون النانوية هي ألياف نانوية تنمو بشكل مستمر عن طريق الترسيب في الطور البخاري، يتراوح قطرها بين 120-200 نانومتر. تتميز بموصلية عالية، وقوة عالية، ومرونة جيدة، وسهولة التشتت. وهي لا غنى عنها للعديد من التطبيقات الموصلة.',
      placeholder: 'ألياف الكربون النانوية'
    },
    material5: {
      title: 'مادة الجرافيت المسامية المركبة',
      description: 'الكربون اللين المسامي هو مادة كربون صناعية ذات مساحة سطح نوعية عالية، وحجم مسام، وحجم مسام، وهيكل جرافيت معين، وبالتالي فهي مادة أنود خاصة لبطاريات الليثيوم تتميز بالشحن السريع والأداء طويل الأمد. من خلال تركيبة خاصة وتقنية معالجة، تتمتع هذه المادة بقدرة عالية (>350 مللي أمبير/جم) وكفاءة مرضية في الشحن والتفريغ الأوليين.',
      placeholder: 'جرافيت مسامي مركب'
    },
    material6: {
      title: 'منتجات جديدة قيد البحث والتطوير',
      description: 'مع تطور العلوم والتكنولوجيا وتحسن مستوى معيشة الناس، تتطور مواد الكربون الجديدة بسرعة، ومن المتوقع إنتاج المزيد والمزيد من منتجات مواد الكربون.',
      placeholder: 'معدات البحث والتطوير'
    }
  },
  news: {
    title: 'المركز الإخباري',
    newsCenter: 'أخبار الشركة',
    subtitle: 'اكتشف آخر أخبار الشركة ومعلومات الصناعة',
    viewAll: 'عرض جميع الأخبار',
    developing: 'ميزة عرض جميع الأخبار قيد التطوير',
    releaseTime: 'وقت النشر',
    learnMore: 'تعرف على المزيد',
    emptyHint: 'لا توجد أخبار منشورة حتى الآن. يرجى العودة لاحقًا.',

    news1: {
      title: 'اختراق تقني في المواد الجديدة',
      summary: 'لقد حققنا اختراقًا تقنيًا كبيرًا في مجال مواد الكربون، وسيوفر المنتج الجديد للعملاء حلولًا ذات جودة أعلى...'
    },
    news2: {
      title: 'الإنتاج الأخضر والصديق للبيئة',
      summary: 'تلتزم الشركة بالإنتاج الصديق للبيئة، وتعتمد أحدث التقنيات النظيفة، وتساهم في التنمية المستدامة...'
    },
    news3: {
      title: 'مشروع التعاون الدولي',
      summary: 'تم التوصل إلى تعاون استراتيجي مع شركات عالمية مشهورة لدفع البحث والتطوير وتطبيق مواد الطاقة الجديدة بشكل مشترك...'
    },
    news4: {
      title: 'توسيع فريق البحث والتطوير',
      summary: 'يستمر حجم فريق البحث والتطوير لدينا في التوسع، مما يجذب المزيد من خبراء الصناعة للانضمام إلى فريقنا...'
    },
    news5: {
      title: 'شهادة جودة المنتج',
      summary: 'لقد حصلت منتجاتنا على العديد من شهادات الجودة الدولية، مما يوفر للعملاء ضمانًا أكثر موثوقية...'
    },
    news6: {
      title: 'جوائز الابتكار التقني',
      summary: 'فازت الشركة بجائزة الابتكار التقني الصناعي، مما يدل على إنجازاتنا المتميزة في البحث والتطوير التقني...'
    },
    news7: {
      title: 'خطة التوسع في السوق',
      summary: 'لقد قمنا بصياغة خطة توسع جديدة للسوق، والتي ستزيد من تأثيرنا في السوق...'
    },
    news8: {
      title: 'الحصول على الشهادات البيئية',
      summary: 'حصلت الشركة على العديد من الشهادات البيئية، مما يعكس التزامنا بالتنمية المستدامة...'
    },
    news9: {
      title: 'التحول الرقمي',
      summary: 'نحن ندفع بالتحول الرقمي الشامل لتعزيز كفاءة الإنتاج ومستوى الإدارة...'
    },
    news10: {
      title: 'ترقية التصنيع الذكي',
      summary: 'إدخال أحدث تقنيات التصنيع الذكي لتحقيق أتمتة وإدارة ذكية لعملية الإنتاج...'
    },
    news11: {
      title: 'استراتيجية التنمية المستدامة',
      summary: 'صياغة وتنفيذ استراتيجية التنمية المستدامة، وتحمل المسؤولية الاجتماعية مع ضمان الفوائد الاقتصادية...'
    },
    news12: {
      title: 'برنامج تنمية المواهب',
      summary: 'إطلاق خطة شاملة لتنمية المواهب لتزويد الموظفين بمزيد من فرص التطوير الوظيفي وتحسين المهارات...'
    },
    prevPage: 'الصفحة السابقة',
    nextPage: 'الصفحة التالية',
    viewingNews: 'تصفح الأخبار حاليًا'
  },
  support: {
    title: 'الدعم الفني',
    download: 'تنزيل',
    downloading: 'جارٍ التنزيل',
    document: 'وثيقة',
    downloadReady: 'جاهز. في بيئة الإنتاج، سيؤدي هذا إلى تنزيل حقيقي.',
    downloadError: 'الملف غير متوفر مؤقتًا، يرجى المحاولة مرة أخرى لاحقًا',
    documents: {
      doc1: {
        type: 'ورقة بيانات تقنية',
        title: 'ورقة البيانات التقنية SF9310A-SF9310B'
      },
      doc2: {
        type: 'ورقة بيانات تقنية',
        title: 'ورقة البيانات التقنية SF9620A-SF9620B'
      },
      doc3: {
        type: 'ورقة بيانات تقنية',
        title: 'ورقة البيانات التقنية SF9270A-SF9270B'
      },
      doc4: {
        type: 'مواصفات المنتج',
        title: 'مواصفات منتج أنابيب الكربون النانوية'
      },
      doc5: {
        type: 'دليل الاستخدام',
        title: 'دليل استخدام المعجون الموصل'
      },
      doc6: {
        type: 'دليل التطبيق',
        title: 'دليل التطبيق في درجات الحرارة العالية'
      },
      doc7: {
        type: 'ورقة بيانات السلامة',
        title: 'ورقة بيانات سلامة المواد'
      },
      doc8: {
        type: 'كتالوج المنتجات',
        title: 'كتالوج المنتجات لعام 2024'
      },
      doc9: {
        type: 'دليل التثبيت',
        title: 'دليل تثبيت المنتج'
      },
      doc10: {
        type: 'شهادة الاعتماد',
        title: 'شهادة اعتماد ISO'
      }
    }
  },
  hr: {
    title: 'الموارد البشرية',
    subtitle: 'انضم إلينا، لنصنع مستقبلاً أفضل معاً',
    description: 'نحن ملتزمون بتوفير منصة تطوير واسعة ومزايا تنافسية للمواهب المتميزة، ونتطلع إلى العمل معكم لخلق مستقبل أفضل',
    joinUs: 'يرجى إرسال سيرتك الذاتية إلى البريد الإلكتروني {email} وسيقوم فريق الموارد البشرية لدينا بالاتصال بك في أقرب وقت ممكن. هاتف {phone} السيد تشن',
    currentOpenings: 'الوظائف الشاغرة حاليًا',
    fields: {
      address: 'العنوان',
      branch: 'القسم',
      workingYears: 'سنوات الخبرة',
      education: 'المؤهل التعليمي',
      hiring: 'عدد الموظفين المطلوبين',
      releaseDate: 'تاريخ النشر'
    },
    whyJoinUs: 'لماذا تختارنا',
    keyRequirements: 'المتطلبات الرئيسية',
    applyNow: 'تقدم الآن',
    expand: 'توسيع',
    collapse: 'طي',
    fullRequirements: 'متطلبات الوظيفة',
    responsibilities: 'المسؤوليات الوظيفية',
    benefits: 'المزايا والبدلات',
    contactInfo: 'معلومات الاتصال',
    contactEmail: 'البريد الإلكتروني',
    contactPhone: 'الهاتف',
    noPositions: 'لا توجد وظائف شاغرة حاليًا',
    thankYou: 'نشكرك على تقديم طلبك',
    position: 'الوظيفة',
    sendResume: 'سنقوم بمعالجة طلبك في أقرب وقت ممكن',
    jobs: {
      seniorEngineer: {
        title: 'مهندس مواد أول',
        address: 'رقم 688، طريق شيفينغ، منطقة نانتايهو الجديدة، مدينة هوتشو، مقاطعة تشجيانغ، الصين',
        branch: 'قسم البحث والتطوير',
        workingYears: '3-5 سنوات',
        education: 'درجة الماجستير',
        hiring: 'شخصان',
        releaseDate: '2025-01-15',
        type: 'دوام كامل',
        location: 'هوتشو، الصين',
        experience: '3-5 سنوات',
        salary: '¥20K-35K',
        description: 'انضم إلى فريق البحث والتطوير لدينا لتطوير حلول مبتكرة للجيل القادم من مواد الكربون وتطبيقات تخزين الطاقة.',
        requirements: [
          'درجة الماجستير في علوم المواد، الهندسة الكيميائية، أو مجال ذي صلة',
          'أكثر من 3 سنوات من الخبرة في البحث والتطوير في مواد الكربون أو المواد المركبة',
          'إجادة تقنيات توصيف المواد',
          'قدرات تحليلية وحل مشكلات قوية',
          'مهارات تواصل ممتازة باللغتين الصينية والإنجليزية'
        ],
        responsibilities: [
          'المسؤولية عن البحث والتطوير وتحسين منتجات مواد الكربون',
          'تصميم وتنفيذ خطط التجارب وتحليل النتائج التجريبية',
          'التعاون مع فرق متعددة الأقسام لدفع تقدم المشروع',
          'كتابة التقارير التقنية وطلبات براءات الاختراع',
          'المشاركة في التبادلات التقنية مع العملاء والترويج للمنتجات'
        ],
        benefits: [
          'مزايا تنافسية في الراتب',
          'تأمين اجتماعي وخمسة أنواع من التأمين بالإضافة إلى التأمين الطبي التجاري',
          'فحص طبي سنوي',
          'فرص التدريب والتطوير المهني',
          'ساعات عمل مرنة وبيئة مكتبية مريحة'
        ]
      },
      rdScientist: {
        title: 'عالم بحث وتطوير',
        address: 'منطقة تشانغجيانغ للتكنولوجيا الفائقة، منطقة بودونغ الجديدة، شنغهاي، الصين',
        branch: 'مركز البحث والتطوير',
        workingYears: '2-4 سنوات',
        education: 'درجة البكالوريوس',
        hiring: '3 أشخاص',
        releaseDate: '2025-01-10',
        type: 'دوام كامل',
        location: 'شنغهاي، الصين',
        experience: '2-4 سنوات',
        salary: '¥15K-25K',
        description: 'المشاركة في مشاريع بحثية مبتكرة تركز على مواد الكربون النانوية المتقدمة وتطبيقاتها الصناعية.',
        requirements: [
          'درجة البكالوريوس في الكيمياء، علوم المواد، أو مجال ذي صلة',
          'أكثر من سنتين من الخبرة في البحث في المواد النانوية',
          'خبرة في تركيب وتوصيف مواد الكربون',
          'مهارات مختبرية قوية واهتمام بالتفاصيل',
          'القدرة على العمل بشكل مستقل وفي فريق'
        ],
        responsibilities: [
          'إجراء أبحاث في تركيب وتوصيف مواد الكربون النانوية',
          'تحسين معايير عملية تصنيع المواد',
          'إجراء اختبارات أداء المنتج وتحليل البيانات',
          'المساعدة في صياغة خطط مشاريع البحث والتطوير',
          'التعاون مع فريق التصنيع لدفع التحول التقني'
        ],
        benefits: [
          'راتب أساسي تنافسي',
          'نظام تأمين اجتماعي متكامل',
          'مكافآت المشاريع ومكافأة نهاية العام',
          'فرص للتبادل الأكاديمي والتدريب',
          'بيئة ومعدات بحث وتطوير ممتازة'
        ]
      },
      processEngineer: {
        title: 'مهندس عمليات',
        address: 'رقم 688، طريق شيفينغ، منطقة نانتايهو الجديدة، مدينة هوتشو، مقاطعة تشجيانغ، الصين',
        branch: 'قسم الإنتاج',
        workingYears: '1-3 سنوات',
        education: 'درجة البكالوريوس',
        hiring: '5 أشخاص',
        releaseDate: '2025-01-08',
        type: 'دوام كامل',
        location: 'هوتشو، الصين',
        experience: '1-3 سنوات',
        salary: '¥12K-20K',
        description: 'تحسين عملية الإنتاج لضمان جودة وكفاءة منتجات مواد الكربون.',
        requirements: [
          'درجة البكالوريوس في الهندسة الكيميائية أو مجال ذي صلة',
          'أكثر من سنة من الخبرة في الإنتاج الكيميائي',
          'فهم لمراقبة الجودة وإجراءات السلامة',
          'قدرات تحليلية وحل مشكلات قوية',
          'روح فريق جيدة'
        ],
        responsibilities: [
          'الإشراف على وتحسين سير عملية إنتاج مواد الكربون',
          'إجراء تعديلات على معايير العملية وصيانة المعدات',
          'تنفيذ إجراءات مراقبة الجودة لضمان مواصفات المنتج',
          'تحليل بيانات الإنتاج وتقديم اقتراحات للتحسين',
          'المشاركة في تطوير والتحقق من العمليات الجديدة'
        ],
        benefits: [
          'دخل ثابت للراتب',
          'تأمين اجتماعي وخمسة أنواع من التأمين متكاملة',
          'فرص التدريب لرفع مستوى المهارات',
          'ضمان استقرار العمل',
          'بيئة عمل ممتازة وروح فريق جيدة'
        ]
      }
    },
    culture: {
      innovation: {
        title: 'مدفوع بالابتكار',
        description: 'نحن نشجع التفكير الابتكاري ونستثمر في البحث والتطوير التقني المتقدم، لنجعل أفكارك تزدهر هنا.'
      },
      growth: {
        title: 'التطوير الوظيفي',
        description: 'نظام تدريب كامل ومسار ترقية لدعم نموك الوظيفي وتطورك الشخصي.'
      },
      teamwork: {
        title: 'العمل الجماعي',
        description: 'فريق دولي متنوع، بيئة عمل مفتوحة وشاملة، السعي المشترك نحو التميز.'
      },
      benefits: {
        title: 'المزايا والبدلات',
        description: 'راتب تنافسي، مزايا تأمين اجتماعي كاملة، فحص طبي سنوي، أنشطة بناء الفريق، ومزايا أخرى غنية.'
      }
    }
  },
  contact: {
    title: 'اتصل بنا',
    titleCard: 'اتصل بنا',
    subtitle: 'يمكنك التواصل معنا عبر الطرق التالية',
    contactInfo: 'معلومات الاتصال',
    phone: 'هاتف',
    overseasOffice: 'المكتب الخارجي',
    usOffice: 'مكتب الولايات المتحدة',
    usAddress: 'هيوستن، تكساس، الولايات المتحدة الأمريكية',
    usAddressFull: '12603 Southwest Fwy, Suite 210, Stafford, Texas 77477, USA',
    mapLoadError: 'فشل تحميل الخريطة، يرجى المحاولة مرة أخرى لاحقًا',
    mapAlt: 'خريطة موقع الشركة - رقم 688، طريق شيفينغ، منطقة نانتايهو الجديدة، مدينة هوتشو، مقاطعة تشجيانغ، الصين',
    companyName: 'هوتشو أوميكيميكال',
    phoneConsultation: 'استشارة هاتفية',
    phoneHours: 'من الاثنين إلى الجمعة 9:00-18:00',
    email: 'البريد الإلكتروني',
    emailNote: 'رد في غضون 24 ساعة',
    address: 'عنوان الشركة',
    addressNote: 'منطقة نانتايهو الجديدة، مدينة هوتشو، مقاطعة تشجيانغ، الصين',
    onlineSupport: 'خدمة العملاء عبر الإنترنت',
    onlineSupportNote: 'انقر لبدء الدردشة',
    supportHours: 'أيام العمل 9:00-22:00',
    messageConsultation: 'استشارة رسالة',
    nameLabel: '* الاسم',
    namePlaceholder: 'الرجاء إدخال اسمك',
    phoneLabel: 'هاتف',
    phonePlaceholder: 'الرجاء إدخال رقم هاتفك',
    emailLabel: 'بريد إلكتروني',
    emailPlaceholder: 'الرجاء إدخال بريدك الإلكتروني',
    companyLabel: 'الشركة',
    companyPlaceholder: 'الرجاء إدخال اسم شركتك',
    messageLabel: 'محتوى الرسالة',
    messagePlaceholder: 'الرجاء إدخال محتوى رسالتك',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    companyLocation: 'موقع الشركة',
    companyFullName: 'شركة هوتشو أوميكيميكال المحدودة',
    postalCode: 'الرمز البريدي',
    loadingMap: 'جارٍ تحميل الخريطة...',
    mapNote: 'في المشروع الفعلي، يمكن دمج واجهة برمجة تطبيقات Baidu Map أو Amap',
    nameRequired: 'الرجاء إدخال الاسم',
    emailInvalid: 'الرجاء إدخال عنوان بريد إلكتروني صحيح',
    submitSuccess: 'تم إرسال رسالتك بنجاح، وسنتواصل معك في أقرب وقت ممكن',
    calling: 'جارٍ الاتصال بالرقم 0572-2678666',
    openingEmail: 'جارٍ فتح عميل البريد الإلكتروني الخاص بك',
    onlineServiceDeveloping: 'وظيفة خدمة العملاء عبر الإنترنت قيد التطوير، يرجى التواصل معنا عبر الهاتف أو البريد الإلكتروني',
    emailSubject: 'استفسار',
    emailBody: 'مرحباً، أود معرفة المزيد من المعلومات.'
  },
  language: {
    title: 'اختيار اللغة',
    subtitle: 'اختر لغتك المفضلة',
    description: 'نحن ملتزمون بتوفير دعم متعدد اللغات للمستخدمين العالميين، لتمكين المزيد من الأشخاص من استخدام خدماتنا بسهولة.',
    contactNote: 'إذا كنت بحاجة إلى دعم بلغات أخرى، يرجى الاتصال بفريق خدمة العملاء لدينا.',
    current: 'الاختيار الحالي',
    switchSuccess: 'تم تغيير اللغة إلى:',
    chineseSimplified: 'الصينية المبسطة',
    chineseTraditional: 'الصينية التقليدية',
    english: 'الإنجليزية',
    spanish: 'الإسبانية',
    chineseSimplifiedDesc: 'الصينية القياسية المستخدمة في البر الرئيسي للصين',
    chineseTraditionalDesc: 'الصينية التقليدية المستخدمة في منطقة تايوان',
    englishDesc: 'الإنجليزية الأمريكية القياسية',
    spanishDesc: 'الإسبانية القياسية'
  },
  shareModal: {
    title: 'مشاركة الصفحة',
    selectPlatform: 'اختر منصة المشاركة',
    copyLink: 'نسخ الرابط',
    copy: 'نسخ',
    copySuccess: 'تم نسخ الرابط بنجاح!',
    wechatTip: 'ميزة مشاركة WeChat قيد التطوير، يمكنك نسخ الرابط ومشاركته يدويًا',
    shareToFacebook: 'مشاركة على Facebook',
    shareToLinkedIn: 'مشاركة على LinkedIn'
  },
  languageWelcome: {
    title: 'أهلاً بك، يرجى اختيار لغتك',
    subtitle: 'نحن نقدم لك دعمًا متعدد اللغات، يرجى اختيار لغتك المفضلة',
    note: 'يمكنك تغيير تفضيلات اللغة في الإعدادات في أي وقت',
    switchSuccess: 'تم تغيير اللغة إلى:'
  },
  menuCarousel: {
    home: {
      title: 'الصفحة الرئيسية',
      subtitle: 'مرحبًا بك في هوتشو أوميكيميكال',
      description: 'شركة متخصصة في تصنيع المنتجات الكيميائية، ملتزمة بتزويد العملاء بمنتجات وخدمات عالية الجودة',
      viewMore: 'تعرف على المزيد'
    },
    about: {
      title: 'من نحن',
      subtitle: 'موازنة احتياجات البشر من الطاقة والبيئة من خلال الابتكار',
      description: 'شركة هوتشو أوميكيميكال المحدودة، تركز على البحث والتطوير وإنتاج المنتجات عالية التقنية، وأصبحت شركة رائدة في الصناعة',
      viewMore: 'عرض التفاصيل'
    },
    solventFreeProducts: {
      title: 'لاصق خالي من المذيبات',
      subtitle: 'لاصق مركب صديق للبيئة وخالٍ من المذيبات',
      description: 'لاصق مركب عالي الأداء وخالٍ من المذيبات، مناسب لمجموعة متنوعة من سيناريوهات التطبيق مثل تغليف المواد الغذائية، يتميز بكونه صديقًا للبيئة وآمنًا وفعالاً',
      viewMore: 'عرض المنتجات'
    },
    esterSolventProducts: {
      title: 'لاصق مذيب إستري',
      subtitle: 'لاصق مركب مذيب إستري عالي الأداء',
      description: 'لاصق مركب مذيب إستري احترافي، يتميز بأداء ربط ممتاز، ويستخدم على نطاق واسع في مواد التغليف المختلفة',
      viewMore: 'عرض المنتجات'
    },
    alcoholicSolventProducts: {
      title: 'لاصق مذيب كحولي',
      subtitle: 'لاصق مركب مذيب كحولي عالي الأداء',
      description: 'لاصق مركب مذيب كحولي احترافي، يتميز بأداء ربط ممتاز، ويستخدم على نطاق واسع في مواد التغليف المختلفة',
      viewMore: 'عرض المنتجات'
    },
    materials: {
      title: 'مواد الكربون الجديدة',
      subtitle: 'تقنية مواد الكربون المتقدمة',
      description: 'تشمل بشكل رئيسي أنابيب الكربون النانوية والمعجون، وألياف الكربون النانوية، ومواد الأنود القائمة على الجرافيت المتعدد، والمواد اللاصقة المائية، وN-ميثيل بيروليدون',
      viewMore: 'تعرف على المزيد'
    },
    news: {
      title: 'المركز الإخباري',
      subtitle: 'اكتشف آخر أخبار الشركة',
      description: 'احصل على آخر أخبار الشركة وتطورات الصناعة، وافهم آخر التقدم الذي أحرزناه في الابتكار التقني وتوسيع السوق',
      viewMore: 'عرض الأخبار'
    },
    support: {
      title: 'الدعم الفني',
      subtitle: 'وثائق ودعم تقني متخصص',
      description: 'توفير أوراق بيانات تقنية كاملة، ومواصفات المنتج، وأدلة الاستخدام وغيرها من الوثائق المتخصصة، لتقديم دعم فني شامل للعملاء',
      viewMore: 'الحصول على الدعم'
    },
    hr: {
      title: 'الموارد البشرية',
      subtitle: 'انضم إلينا، لنصنع مستقبلاً أفضل معاً',
      description: 'ندعو المواهب من جميع المجالات للانضمام إلى فريقنا، وتقديم مزايا تنافسية ومساحة تطوير واسعة',
      viewMore: 'عرض الوظائف'
    },
    contact: {
      title: 'اتصل بنا',
      subtitle: 'تواصل معنا في أي وقت',
      description: 'نتطلع إلى التعاون معكم، وتوفير استشارات ودعم خدمات احترافية لكم من خلال طرق متعددة',
      viewMore: 'معلومات الاتصال'
    }
  },
  productsPage: {
    pageTitle: 'المواد اللاصقة',
    title: 'تعريف بالمنتجات',
    meta: {
      description: 'تعريف بمنتجات شركة هوتشو أوميكيميكال المحدودة - لاصق مركب للتغليف المرن، لاصق هيكلي هندسي ومنتجات كيميائية احترافية أخرى'
    },
    solventFree: {
      title: 'لاصق خالي من المذيبات',
      subtitle: 'لاصق خالي من المذيبات'
    },
    esterSolvent: {
      title: 'لاصق مذيب إستري',
      subtitle: 'لاصق مذيب إستري'
    },
    performanceLevel:"مستوى الأداء",
    icons: {
      lamination: {
        main: 'تصفيح',
        sub: 'LAMINATION'
      },
      boiling: {
        main: 'غليان 100°C/30 دقيقة شفاف',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'تعقيم',
        sub: 'RETORT'
      },
      specialities: {
        main: 'خصائص خاصة',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: 'مقاومة كيميائية',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: 'عالي الأداء',
      highSub: 'High Performance',
      medium: 'متوسط الأداء',
      mediumSub: 'Medium Performance',
      standard: 'اقتصادي',
      standardSub: 'Cost Effective'
    }
  },
  solventFreeProductsPage: {
    pageTitle: 'لاصق خالي من المذيبات',
    title: 'لاصق خالي من المذيبات-تعريف بالمنتجات',
    meta: {
      description: 'تعريف بمنتجات شركة هوتشو أوميكيميكال المحدودة - لاصق مركب للتغليف المرن، لاصق هيكلي هندسي ومنتجات كيميائية احترافية أخرى'
    },
    solventFree: {
      title: 'لاصق خالي من المذيبات',
      subtitle: 'لاصق شامل أول الاختيار للتصفيح بالتغليف المرن'
    },
    performanceLevel:"مستوى الأداء",
    icons: {
      lamination: {
        main: 'تصفيح',
        sub: 'LAMINATION'
      },
      boiling: {
        main: 'غليان 100°C/30 دقيقة شفاف',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'تعقيم',
        sub: 'RETORT'
      },
      specialities: {
        main: 'خصائص خاصة',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: 'مقاومة كيميائية',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: 'عالي الأداء',
      highSub: 'High Performance',
      medium: 'متوسط الأداء',
      mediumSub: 'Medium Performance',
      standard: 'اقتصادي',
      standardSub: 'Cost Effective'
    },
    features: 'ميزة'
  },
  esterSolventProductsPage: {
    pageTitle: 'لاصق مذيب إستري',
    title: 'لاصق مذيب إستري-تعريف بالمنتجات',
    meta: {
      description: 'تعريف بمنتجات شركة هوتشو أوميكيميكال المحدودة - لاصق مركب للتغليف المرن، لاصق هيكلي هندسي ومنتجات كيميائية احترافية أخرى'
    },
    esterSolvent: {
      title: 'لاصق مذيب إستري',
      subtitle: 'لاصق شامل أول الاختيار للتصفيح بالتغليف المرن'
    },
    performanceLevel:"مستوى الأداء",
    icons: {
      lamination: {
        main: 'تصفيح',
        sub: 'LAMINATION'
      },
      boiling: {
        main: 'غليان 100°C/30 دقيقة شفاف',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'تعقيم',
        sub: 'RETORT'
      },
      specialities: {
        main: 'خصائص خاصة',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: 'مقاومة كيميائية',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: 'عالي الأداء',
      highSub: 'High Performance',
      medium: 'متوسط الأداء',
      mediumSub: 'Medium Performance',
      standard: 'اقتصادي',
      standardSub: 'Cost Effective'
    },
    features: 'ميزة'

  },
  alcoholicSolventProductsPage: {
    pageTitle: 'لاصق مذيبات الكحول',
    title: 'لاصق مذيبات الكحول-تعريف بالمنتجات',
    meta: {
      description: 'تعريف بمنتجات شركة هوتشو أوميكيميكال المحدودة - لاصق مركب للتغليف المرن، لاصق هيكلي هندسي ومنتجات كيميائية احترافية أخرى'
    },
    alcoholicSolvent: {
      title: 'لاصق مذيبات الكحول',
      subtitle: 'لاصق شامل أول الاختيار للتصفيح بالتغليف المرن'
    },
    performanceLevel: 'مستوى الأداء',
    icons: {
      lamination: {
        main: 'تصفيح',
        sub: 'LAMINATION'
      },
      boiling: {
        main: 'غليان 100°C/30 دقيقة شفاف',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'تعقيم',
        sub: 'RETORT'
      },
      specialities: {
        main: 'خصائص خاصة',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: 'مقاومة كيميائية',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: 'عالي الأداء',
      highSub: 'High Performance',
      medium: 'متوسط الأداء',
      mediumSub: 'Medium Performance',
      standard: 'اقتصادي',
      standardSub: 'Cost Effective'
    },
    features: 'ميزة'

  },
  companyName: 'شركة هوتشو أوكيم للكيماويات المحدودة'
}